$('.js-hamburger').on('click', (e) => {
	$('body').toggleClass('filter-open');
	$('.filter').fadeToggle().toggleClass('is-active');

	if ($(e.currentTarget).hasClass('is-active')) {
		$(e.currentTarget).removeClass('is-active');
	} else {
		$('.filter__container').scrollTop(0);
		$(e.currentTarget).addClass('is-active');
	}
});

$('.filter-open').on('touchmove', (e) => {
	e.preventDefault();
});
